export default __webpack_public_path__ + "static/media/hero.e46aa12e.webp";